import React, {useState, useEffect, useRef} from 'react'
import axios from 'axios'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import styled from 'styled-components'
import Form from 'react-bootstrap/Form'
import { Link } from 'react-router-dom'
import TextIcon from '../Icons/TextIcon'
import Modal from 'react-bootstrap/Modal'
import { useForm } from 'react-hook-form'
import EmailIcon from '../Icons/EmailIcon'
import LoginIcon from '../Icons/LoginIcon'
import Button from 'react-bootstrap/Button'
import { useAuth } from '../Context/auth.js'
import useWidth from '../Functions/useWidth'
import HelpIcon from '../Icons/HelpIcon.js'
import { useHistory } from 'react-router-dom'
import getUser from '../Functions/getUser.js'
import Spinner from 'react-bootstrap/Spinner'
import CaseDetailModal from './CaseDetailModal'
import StepNextIcon from '../Icons/StepNextIcon'
import Container from 'react-bootstrap/Container'
import { useTokenContext } from '../Context/token'
import { startRegistration, startAuthentication } from '@simplewebauthn/browser'
import NewtonCradleLoader from './NewtonCradleLoader'

const LoginFormContainer = styled.div`
  .color {
    color: #F5F5FC;
  }
`
const Loginform = (props) => {
   
  const width = useWidth()
  const history = useHistory()
  const { setAuthTokens } = useAuth()
  const [host, setHost] = useState('')
  const { setTokenState } = useTokenContext()
  const [showModal, setShowModal] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const { register, handleSubmit, setValue, getValues } = useForm()
  const [modalMessage, setModalMessage] = useState('')

  const [locked, setLocked] = useState(true)
  const [userId, setUserId] = useState(undefined)
  const [username, setUsername] = useState(undefined)
  const [password, setPassword] = useState(undefined)
  const [usePassword, setUsePassword] = useState(false) 
  const [deviceName, setDeviceName] = useState(undefined)
  const [showCodeOptions, setShowCodeOptions] = useState(false)
  const [showPasskeyHelp, setShowPasskeyHelp] = useState(false)
  const [showDeviceNameHelp, setShowDeviceNameHelp] = useState(false)

  const [display, setDisplay] = useState({
    code: false, 
    username: true, 
    password: false,
    codeChoice: false,
    passkeyName: false,
    passkeyChoice: false,
    passkeyCode: false,
  })

  const [tries, setTries] = useState(0)

  const inputs = useRef([])

  const api = axios.create({
    baseURL:'/',
    withCredentials: true
  })

  useEffect(() => {
    const getHost = async () => {
      try {

        inputs.current = inputs.current.slice(0, 6)
        for (let i = 0; i < 6; i++) {
          if (!inputs.current[i]) {
            inputs.current[i] = React.createRef()
          }
        }

        const response = await axios.post('/getHost')
        setHost(response.data.host)

        const lockState = await axios.post('/getIpLockState')
        if (lockState.data.ok) {
          setLocked(false)
        }
        setIsLoading(false)
      } catch (e) {
        setModalMessage(`Error! ${e}`)
        setShowModal(true)
      } 
    }
    getHost()
  }, [])
    
  const onSubmit = async (data) => {
    const post = async (data) => {
      await axios.post(props.url, {
        user: data.user,
        pass: data.pass
      }).then((response) => {
          if (!response.data.failure) {
            setAuthTokens(response.data)
            setTokenState(true)
            const user = getUser()

            if (user.cleaner) {
              history.push('/cleaners')
            } else if (user.role === 10) {
              history.push('/sensors')
            } else {
              history.push('/status')
            }
          }
          if (response.data.failure === 'noMatch') {
            setModalMessage('That password does not match our records. Try again.')
            setShowModal(true)
          }

          if (response.data.failure === 'noUser') {
            setModalMessage('That user does not match our records. Try again.')
            setShowModal(true)
          }

          if (response.data.failure === 'license') {
            setModalMessage('Your license has expired. Please contact FX cinema software at 740-988-6273.')
            setShowModal(true)
          }

          if (response.data.failure === 'default') {
            setModalMessage('You need to change the default password. Please check your email.')
            setShowModal(true)
          }
      }).catch((e) =>{
        setModalMessage(`Sad! We encounted a problem, try again later. ${e}`)
        setShowModal(true)
      })
    }  
    post(data)
  }

  const usernameSubmit = async (data) => {
    try {
      if (data.user) {
        const response = await axios.post('/checkUsername', {
          username: data.user
        })
        if (response.data.ok) {
          setUsername(data.user)
          setUserId(response.data.userId)

          if (data.usePassword) {
            setDisplay({
              code: false, 
              username: false, 
              password: true,
              codeChoice: false,
              passkeyName: false,
              passkeyChoice: false,
              passkeyCode: false,
            })
          } else {
            const checkForPasskey = await api.post('/generateAuthOptions', {
              userId: response.data.userId
            })

            if (checkForPasskey.data.noPasskeys) {
              setDisplay({
                code: false, 
                username: false, 
                password: true,
                codeChoice: false,
                passkeyName: false,
                passkeyChoice: false,
                passkeyCode: false,
              })
            } else {
              
              const cred = await startAuthentication({ optionsJSON: checkForPasskey.data})

              const loginVerify = await api.post('/verifyAuth', {
                userId: response.data.userId,
                credential: cred
              }) 

              if (!loginVerify.data.failure) {
                
                setAuthTokens(loginVerify.data)
                setTokenState(true)
                const user = getUser()
        
                 if (user.cleaner) {
                  history.push('/cleaners')
                } else if (user.role === 10) {
                  history.push('/sensors')
                } else {
                  history.push('/status')
                }
              }
              if (loginVerify.data.failure) {
                setModalMessage(`Login failure! ${loginVerify.data.failure}`)
                setShowModal(true)
              }
            } 
          }   
        } else if (response.data.lockout) {
          //too many bad user names
          setLocked(true)

        } else if (response.data.incorrect) { 
          //username given not valid
          if (tries >= 5) {
            const lockout = await axios.post('/addLoginFailure')
            if (lockout.status === 200) {
              setLocked(true)
            }
          } else {
            setTries(tries + 1) 
            setModalMessage(`User not found. ${5 -(tries + 1)} attempts left.`)
            setShowModal(true)
          }
        }
      }
    } catch (e) {
      setModalMessage(`Error! ${e}`)
      setShowModal(true)
    }
  }

  const passwordSubmit = async (data) => {
    try {   
      
      const response = await axios.post('/checkPassword', {
        userId: userId,
        password: data.password
      })
      //cleaner login expired license
      if (response.data.failure === 'license') {
        setModalMessage('Your license has expired. Please contact FX cinema software at 740-988-6273.')
        setShowModal(true)
      } else if (response.data.login) {
        //cleaner login success
      
        setAuthTokens(response.data.token)
        setTokenState(true)
        const user = getUser()

        if (user.cleaner) {
          history.push('/cleaners')
        } else if (user.role === 10) {
          history.push('/sensors')
        } else {
          history.push('/status')
        }
          
      } else if (response.data.success) {
        //correct password, not cleaner
        setPassword(data.password)
        setDisplay({
          code: false, 
          username: false, 
          password: false,
          codeChoice: true,
          passkeyName: false,
          passkeyChoice: false,
          passkeyCode: false,
        })
      } else {
        if (tries >= 5) {
          const lockout = await axios.post('/addLoginFailure')
          if (lockout.status === 200) {
            setLocked(true)
          }
        } else {
          setTries(tries + 1)
          setModalMessage(`Password incorrect. ${5 - (tries + 1)} attempts left.`)
          setShowModal(true)
        }
      }
      
    } catch (e) {
      setModalMessage(`Error! ${e}`)
      setShowModal(true)
    }
  }

  const codeSubmit = async (data) => {
    try {
      const code = Object.values(data).join('')
      const codeCheck = await axios.post('/loginCodeCheck', {
        userId: userId,
        code: code
      })
      if (codeCheck.data.failure) {
        setModalMessage('Code not found. Try again or request anothet code.')
      }
      if (codeCheck.data.ok) {
        const login = await axios.post('/loginUser', {
          user: username,
          pass: password
        })

        setAuthTokens(login.data)
        setTokenState(true)
        const user = getUser()

        if (user.cleaner) {
          history.push('/cleaners')
        } else if (user.role === 10) {
          history.push('/sensors')
        } else {
          history.push('/status')
        }

        if (login.data.failure === 'noMatch') {
          setModalMessage('That password does not match our records. Try again.')
          setShowModal(true)
        }

        if (login.data.failure === 'noUser') {
          setModalMessage('That user does not match our records. Try again.')
          setShowModal(true)
        }

        if (login.data.failure === 'license') {
          setModalMessage('Your license has expired. Please contact FX cinema software at 740-988-6273.')
          setShowModal(true)
        }

        if (login.data.failure === 'default') {
          setModalMessage('You need to change the default password. Please check your email.')
          setShowModal(true)
        }
      } else {
        //bad code
        setModalMessage(`Invalid code.`)
        setShowModal(true)
      }
    } catch (e) {
      setModalMessage(`Error! ${e}`)
      setShowModal(false)
    }
  }

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, '') // only digits
    setValue(`code${index}`, value)
    if (value && index < 5) inputs.current[index + 1].current.focus()
  }

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !getValues(`code${index}`) && index > 0) {
      inputs.current[index - 1].current.focus()
    }
  }

  const handlePaste = (e) => {
    e.preventDefault()
    const paste = e.clipboardData.getData('Text').trim().slice(0, 6)
    paste.split('').forEach((digit, idx) => {
      if (inputs.current[idx]) {
        // update RHF state
        setValue(`code${idx}`, digit)
        // update DOM value
        inputs.current[idx].current.value = digit
      }
    })
    // focus the next empty box (or last)
    const next = paste.length < 6 ? paste.length : 5
    inputs.current[next].current.focus()
  }

  const sendEmailCode = async () => {
    try {
      const response = await axios.post('/sendEmailLoginCode', {
        userId: userId
      })
      if (response.status === 200) {
        setDisplay({
          code: true, 
          username: false, 
          password: false,
          codeChoice: false,
          passkeyName: false,
          passkeyChoice: false,
          passkeyCode: false,
        })
      }
    } catch (e) {
      setModalMessage(`Error! ${e}`)
      setShowModal(false)
    }
  }

  const sendTextCode = async () => {
    try {
      const response = await axios.post('/sendTextLoginCode', {
        userId: userId
      })
      if (response.status === 200) {
        setDisplay({
          code: true, 
          username: false, 
          password: false,
          codeChoice: false,
          passkeyName: false,
          passkeyChoice: false,
          passkeyCode: false,
        })
      }
    } catch (e) {
      setModalMessage(`Error! ${e}`)
      setShowModal(false)
    }
  }

  const emailPasskeyCode = async () => {
    try {
      const response = await axios.post('/sendEmailPasskeyCode', {
        userId: userId
      })
      if (response.status === 200) {
        setDisplay({
          code: false, 
          username: false, 
          password: false,
          codeChoice: false,
          passkeyName: false,
          passkeyChoice: false,
          passkeyCode: true,
        })
      }
    } catch (e) {
      setModalMessage(`Error! ${e}`)
      setShowModal(false)
    }
  }

  const textPasskeyCode = async () => {
    try {
      const response = await axios.post('/sendTextPasskeyCode', {
        userId: userId
      })
      if (response.status === 200) {
        setDisplay({
          code: false, 
          username: false, 
          password: false,
          codeChoice: false,
          passkeyName: false,
          passkeyChoice: false,
          passkeyCode: true,
        })
      }
    } catch (e) {
      setModalMessage(`Error! ${e}`)
      setShowModal(false)
    }
  }

  const createPasskey = async (data) => {
    try {
      const code = Object.values(data).join('')
      
      const codeCheck = await axios.post('/passkeyCodeCheck', {
        userId: userId,
        code: code
      })

      if (codeCheck.data.failure) {
        setModalMessage('Code not found. Try again or request anothet code.')
      }
      if (codeCheck.data.ok) {
        const contactName = await axios.post('/getUserContactName', {
          userId: userId
        })
        const generate = await api.post('/generateRegistration', {
          userId: userId,
          displayName: contactName.data.contactName,
          username: username
        })
          
        const credentials = await startRegistration({ optionsJSON: generate.data})
        
        const verify = await api.post('/verifyRegistration', {
          userId: userId,
          credential: credentials,
          deviceName: deviceName
        }, {
          withCredentials: true
        }) 

        if (verify.status === 200) {

          const checkForPasskey = await api.post('/generateAuthOptions', {
            userId: userId
          })

          if (checkForPasskey.data.noPasskeys) {
            setDisplay({
              code: false, 
              username: false, 
              password: true,
              codeChoice: false,
              passkeyName: false,
              passkeyChoice: false,
              passkeyCode: false,
            })
          } else {
            
            const cred = await startAuthentication({ optionsJSON: checkForPasskey.data})

            const loginVerify = await api.post('/verifyAuth', {
              userId: userId,
              credential: cred
            }) 

            if (!loginVerify.data.failure) {
              
              setAuthTokens(loginVerify.data)
              setTokenState(true)
              const user = getUser()
      
              if (user.cleaner) {
                history.push('/cleaners')
              } else if (user.role === 10) {
                history.push('/sensors')
              } else {
                history.push('/status')
              }
            }
             if (loginVerify.data.failure) {
              setModalMessage(`Login failure! ${loginVerify.data.failure}`)
              setShowModal(true)
            }
          }  
        }
      }
    } catch (e) {
      setModalMessage(`Error! ${e}`)
      setShowModal(false)
    }
  }

  const saveDeviceName = async (data) => {
    try {
      if (data.user) {
        const response = await axios.post('/checkUsername', {
          username: data.user
        })
        if (response.data.ok) {
          setUsername(data.user)
          setUserId(response.data.userId)

          setDeviceName(data.deviceName)
          setDisplay({
            code: false, 
            username: false, 
            password: false,
            codeChoice: false,
            passkeyName: false,
            passkeyChoice: true,
            passkeyCode: false,
          })
     
        } else if (response.data.lockout) {
          //too many bad user names
          setLocked(true)

        } else if (response.data.incorrect) { 
          //username given not valid
          if (tries >= 5) {
            const lockout = await axios.post('/addLoginFailure')
            if (lockout.status === 200) {
              setLocked(true)
            }
          } else {
            setTries(tries + 1) 
            setModalMessage(`User not found. ${5 -(tries + 1)} attempts left.`)
            setShowModal(true)
          }
        }
      }
    } catch (e) {
      setModalMessage(`Error! ${e}`)
      setShowModal(true)
    }
  }

  return (
    <Container className={props.refactor ? 'auth-refactor-login-form' : undefined}>
      <LoginFormContainer>
        <Modal dialogClassName={props.refactor ? 'newton-refactor-modal auth-refactor-modal' : undefined} show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Body>{modalMessage}</Modal.Body>
        </Modal>
        <Modal dialogClassName={props.refactor ? 'newton-refactor-modal auth-refactor-modal' : undefined} show={showPasskeyHelp} onHide={() => setShowPasskeyHelp(false)} centered>
          <CaseDetailModal
            title='Passkeys'
            closeFunction={() => setShowPasskeyHelp(false)}
          >
            <p style={{color:'#F5F5FC'}}>
              Create a passkey to sign in instantly—on phones with a fingerprint or face scan, or on desktops with Windows Hello, Touch ID, or even a quick system PIN—so you never have to type a password again. Because the key never leaves your device, it can’t be phished or leaked, giving your account the strongest protection available.
            </p>
          </CaseDetailModal>
        </Modal>
        <Modal dialogClassName={props.refactor ? 'newton-refactor-modal auth-refactor-modal' : undefined} show={showDeviceNameHelp} onHide={() => setShowDeviceNameHelp(false)} centered>
          <CaseDetailModal
            title='Device name'
            closeFunction={() => setShowDeviceNameHelp(false)}
          >
            <p style={{color:'#F5F5FC'}}>
              Enter and save a device name for this device...could be "office computer" or "iPhone" etc.   
            </p>
          </CaseDetailModal>
        </Modal>
        {isLoading && (props.refactor ?
          <div className='auth-refactor-loading'><NewtonCradleLoader message='Preparing secure sign in…' size='lg' /></div> :
          <Col style={{paddingTop:'1em'}} lg={{ span: 1, offset: 5 }} md={{ span: 1, offset: 5 }} xs={{span:1, offset:5}}>
            <Spinner style={{color:'#00e5ff', marginBottom:'.5em', height:'1em', width:'1em'}} animation="border" />
          </Col>
        )}
        {!isLoading &&
          <>
            {locked &&
              <>
                <div style={{
                  display:'flex',
                  alignItems:'center',
                  padding:'.5em',
                  marginLeft:'auto',
                  marginRight:'auto',
                  justifyContent:'center'
                }}>
                  <Row>
                    <Col>
                      <p style={{color:'#F5F5FC', fontSize:'1.2em'}}>
                        Too many login attempts...please try again in five minutes.
                      </p>
                    </Col>
                  </Row>
                </div>
              </>
            }
            {!locked &&
              <>
                {width >= 769 ?
                  <>
                    <Row>
                      <Col lg={{ span: 6, offset: 3 }} md={{ span: 8, offset: 2 }} xs={{span:8, offset:2}}>
                        <h4 style={{color:'#00e5ff'}}>Client Login</h4>
                        {display.username &&
                          <Form onSubmit={handleSubmit(usernameSubmit)}>  
                            <Form.Row>
                              <Form.Group as={Col}>
                                <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>Username</Form.Label> 
                                <Form.Control ref={register({ required: true })} name='user' type='text'/>
                              </Form.Group>
                            </Form.Row> 
                            <Form.Row>
                              <Form.Group as={Col}>
                                <Button block
                                  style={{
                                    border:'none',
                                    color:'#F5F5FC', 
                                    backgroundColor:'#242323'
                                }} type='submit'>
                                  <LoginIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Login
                                </Button>
                              </Form.Group>
                            </Form.Row>
                            <Form.Row>
                              <Form.Group as={Col}>
                                <Form.Check 
                                  label='Use password instead of passkey'
                                  style={{color:'#00e5ff', fontSize:'1.2em'}}
                                  name='usePassword'
                                  ref={register()}
                                />
                              </Form.Group>
                            </Form.Row>  
                            <Form.Row>
                              <Form.Group as={Col}>
                                <small>
                                  <Link className='color' to={{
                                      pathname: props.forgotUsernamePath || '/forgotUsername',
                                      }}>Forgot Username</Link>
                                </small>
                              </Form.Group>
                            </Form.Row> 
                            <Form.Row>
                              <Form.Group as={Col}>
                                <br/>
                                <br/>
                              </Form.Group>
                            </Form.Row>
                            <Form.Row>
                              <Form.Group as={Col}>
                                <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>
                                  Create passkey for this device&ensp;
                                  <Button 
                                    size='sm' 
                                    variant='outline-light' 
                                    style={{border:'none', backgroundColor:'transparent'}}
                                    onClick={() => setShowPasskeyHelp(true)}
                                  >
                                      <HelpIcon fill='#00e5ff' height='1.75em' width='1.75em' /> 
                                  </Button>
                                </Form.Label> 
                                <Button
                                  block
                                  style={{
                                    border:'none',
                                    color:'#F5F5FC', 
                                    backgroundColor:'#242323'
                                  }}
                                  onClick={() => setDisplay({
                                    code: false, 
                                    username: false, 
                                    password: false,
                                    codeChoice: false,
                                    passkeyName: true,
                                    passkeyChoice: false,
                                    passkeyCode: false,
                                  })}
                                >
                                  <LoginIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Create Passkey
                                </Button>
                              </Form.Group>    
                            </Form.Row>   
                          </Form>
                        }
                        {display.password &&
                          <Form onSubmit={handleSubmit(passwordSubmit)}>  
                            <Form.Row>
                              <Form.Group as={Col}>
                                <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>Password</Form.Label>
                                <Form.Control ref={register({ required: true })} name='password' type='password'/>
                              </Form.Group>
                            </Form.Row>     
                            <Form.Row>
                              <Form.Group as={Col}>
                                <Button block
                                  style={{
                                    border:'none',
                                    color:'#F5F5FC', 
                                    backgroundColor:'#242323'
                                }} type='submit'>
                                  <LoginIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Login
                                </Button>
                              </Form.Group>
                            </Form.Row>
                            <Form.Row>
                              <Form.Group as={Col}>
                                <small>
                                  <Link className='color' to={{
                                      pathname: props.resetPath || '/resetPassword',
                                      }}>Reset Password</Link>
                                </small>
                              </Form.Group>
                            </Form.Row>
                          </Form>
                        }
                        {display.codeChoice &&
                          <>
                            <Form>
                              <Form.Row>
                                <Form.Group as={Col}>
                                  <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>One time code</Form.Label> 
                                  <Button
                                    block
                                    style={{
                                      border:'none',
                                      color:'#F5F5FC', 
                                      backgroundColor:'#242323'
                                    }}
                                    onClick={() => sendEmailCode()}
                                  >
                                    <EmailIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Email
                                  </Button>
                                  <Button
                                    block
                                    style={{
                                      border:'none',
                                      color:'#F5F5FC', 
                                      backgroundColor:'#242323'
                                    }}
                                    onClick={() => sendTextCode()}
                                  >
                                    <TextIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Text
                                  </Button>
                                </Form.Group>
                              </Form.Row>
                            </Form>
                          </>
                        }
                        {display.code &&
                          <>
                            <Form onSubmit={handleSubmit(codeSubmit)}>
                              <Form.Row>
                                <Form.Group as={Col}>
                                  <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>One time code</Form.Label>
                                  <br/>
                                  <br/>
                                  {inputs.current.map((ref, i) => (
                                    <input
                                      key={i}
                                      name={`code${i}`}
                                      type="text"
                                      maxLength="1"
                                      autoComplete="one-time-code"
                                      inputMode="numeric"
                                      pattern="\d*"
                                      ref={(el) => {
                                        ref.current = el
                                        register(el)
                                      }}
                                      onChange={(e) => handleChange(e, i)}
                                      onKeyDown={(e) => handleKeyDown(e, i)}
                                      onPaste={i === 0 ? handlePaste : undefined} 
                                      style={{ 
                                        width: '2em', 
                                        textAlign: 'center', 
                                        fontSize: '1.5em', 
                                        borderColor:'#00e5ff', 
                                        backgroundColor:'transparent', 
                                        color:'#F5F5FC', 
                                        borderRadius:'.25em', 
                                        marginLeft:'.1em', 
                                        marginRight:'.1em'
                                      }}
                                      
                                    />
                                  ))}
                                  <br/>
                                  <br/>
                                  <Button 
                                    style={{
                                      border:'none',
                                      color:'#F5F5FC', 
                                      backgroundColor:'#242323'
                                    }} 
                                    type="submit"
                                  >
                                    <LoginIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Verify code
                                  </Button>
                                  <br/>
                                  <br/>
                                  <Button size='sm' style={{
                                    border:'none',
                                    color:'#F5F5FC', 
                                    backgroundColor:'#242323'
                                  }}
                                    onClick={() => setShowCodeOptions(!showCodeOptions)}
                                  >
                                    {!showCodeOptions ? 'Request new code' : 'Close'}
                                  </Button>
                                  {showCodeOptions &&
                                    <>
                                      <Form.Row style={{marginTop:'1em'}}>
                                        <Form.Group as={Col}>
                                          <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>One time code</Form.Label> 
                                          <Button
                                            block
                                            style={{
                                              border:'none',
                                              color:'#F5F5FC', 
                                              backgroundColor:'#242323'
                                            }}
                                            onClick={() => sendEmailCode()}
                                          >
                                            <EmailIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Email
                                          </Button>
                                          <Button
                                            block
                                            style={{
                                              border:'none',
                                              color:'#F5F5FC', 
                                              backgroundColor:'#242323'
                                            }}
                                            onClick={() => sendTextCode()}
                                          >
                                            <TextIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Text
                                          </Button>
                                        </Form.Group>
                                      </Form.Row>
                                    </>
                                  }
                                </Form.Group>
                              </Form.Row>
                            </Form>
                          </>
                        }
                        {display.passkeyName &&
                          <>
                            <Form onSubmit={handleSubmit(saveDeviceName)}>
                              <Form.Row>
                                <Form.Group as={Col}>
                                  <Form.Label style={{color:'#F5F5FC', fontSize:'1.4em'}}>Passkey information</Form.Label>
                                </Form.Group>
                              </Form.Row>
                              <Form.Row>
                                <Form.Group as={Col}>
                                  <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>Username</Form.Label> 
                                  <Form.Control ref={register({ required: true })} name='user' type='text'/>
                                </Form.Group>
                              </Form.Row> 
                              <Form.Row>
                                <Form.Group as={Col}>
                                  <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>
                                    Device name&ensp;
                                    <Button 
                                      size='sm' 
                                      variant='outline-light' 
                                      style={{border:'none', backgroundColor:'transparent'}}
                                      onClick={() => setShowDeviceNameHelp(true)}
                                    >
                                        <HelpIcon fill='#00e5ff' height='1.75em' width='1.75em' /> 
                                    </Button>
                                  </Form.Label> 
                                  <Form.Control ref={register({ required: true })} name='deviceName' type='text'/>
                                </Form.Group>
                              </Form.Row>     
                              <Form.Row>
                                <Form.Group as={Col}>
                                  <Button block
                                    style={{
                                      border:'none',
                                      color:'#F5F5FC', 
                                      backgroundColor:'#242323'
                                  }} type='submit'>
                                    Save and continue <StepNextIcon fill='#00e5ff' height='1.25em' width='1.25em' /> 
                                  </Button>
                                </Form.Group>
                              </Form.Row>
                            </Form>
                          </>
                        }
                        {display.passkeyChoice &&
                          <>
                            <Form>
                              <Form.Row>
                                <Form.Group as={Col}>
                                  <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>
                                    Passkey one time code
                                  </Form.Label> 
                                  <Button
                                    block
                                    style={{
                                      border:'none',
                                      color:'#F5F5FC', 
                                      backgroundColor:'#242323'
                                    }}
                                    onClick={() => emailPasskeyCode()}
                                  >
                                    <EmailIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Email
                                  </Button>
                                  <Button
                                    block
                                    style={{
                                      border:'none',
                                      color:'#F5F5FC', 
                                      backgroundColor:'#242323'
                                    }}
                                    onClick={() => textPasskeyCode()}
                                  >
                                    <TextIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Text
                                  </Button>
                                </Form.Group>    
                              </Form.Row>
                            </Form>
                          </>
                        }
                        {display.passkeyCode &&
                          <>
                            <Form onSubmit={handleSubmit(createPasskey)}>
                              <Form.Row>
                                <Form.Group as={Col}>
                                  <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>Passkey code</Form.Label>
                                  <br/>
                                  <br/>
                                  {inputs.current.map((ref, i) => (
                                    <input
                                      key={i}
                                      name={`code${i}`}
                                      type="text"
                                      maxLength="1"
                                      autoComplete="one-time-code"
                                      inputMode="numeric"
                                      pattern="\d*"
                                      ref={(el) => {
                                        ref.current = el
                                        register(el)
                                      }}
                                      onChange={(e) => handleChange(e, i)}
                                      onKeyDown={(e) => handleKeyDown(e, i)}
                                      onPaste={i === 0 ? handlePaste : undefined} 
                                      style={{ 
                                        width: '2em', 
                                        textAlign: 'center', 
                                        fontSize: '1.5em', 
                                        borderColor:'#00e5ff', 
                                        backgroundColor:'transparent', 
                                        color:'#F5F5FC', 
                                        borderRadius:'.25em', 
                                        marginLeft:'.1em', 
                                        marginRight:'.1em'
                                      }}
                                      
                                    />
                                  ))}
                                  <br/>
                                  <br/>
                                  <Button 
                                    style={{
                                      border:'none',
                                      color:'#F5F5FC', 
                                      backgroundColor:'#242323'
                                    }} 
                                    type="submit"
                                  >
                                    <LoginIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Create passkey 
                                  </Button>
                                  <br/>
                                  <br/>
                                  <Button size='sm' style={{
                                    border:'none',
                                    color:'#F5F5FC', 
                                    backgroundColor:'#242323'
                                  }}
                                    onClick={() => setShowCodeOptions(!showCodeOptions)}
                                  >
                                    {!showCodeOptions ? 'Request new code' : 'Close'}
                                  </Button>
                                  {showCodeOptions &&
                                    <>
                                      <Form.Row style={{marginTop:'1em'}}>
                                        <Form.Group as={Col}>
                                          <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>Passkey code</Form.Label> 
                                          <Button
                                            block
                                            style={{
                                              border:'none',
                                              color:'#F5F5FC', 
                                              backgroundColor:'#242323'
                                            }}
                                            onClick={() => emailPasskeyCode()}
                                          >
                                            <EmailIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Email
                                          </Button>
                                          <Button
                                            block
                                            style={{
                                              border:'none',
                                              color:'#F5F5FC', 
                                              backgroundColor:'#242323'
                                            }}
                                            onClick={() => textPasskeyCode()}
                                          >
                                            <TextIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Text
                                          </Button>
                                        </Form.Group>
                                      </Form.Row>
                                    </>
                                  }
                                </Form.Group>
                              </Form.Row>
                            </Form>
                          </>
                        }
                      </Col>
                    </Row>
                  </> : 
                  <>
                    <Row>
                      <Col lg={{ span: 4, offset: 4 }} md={{ span: 8, offset: 2 }} xs={{span:10, offset:1}}>
                        <h4 style={{color:'#00e5ff'}}>Client Login</h4>
                        {display.username &&
                          <Form onSubmit={handleSubmit(usernameSubmit)}>  
                            <Form.Row>
                              <Form.Group as={Col}>
                                <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>Username</Form.Label> 
                                <Form.Control ref={register({ required: true })} name='user' type='text'/>
                              </Form.Group>
                            </Form.Row> 
                            <Form.Row>
                              <Form.Group as={Col}>
                                <Button block
                                  style={{
                                    border:'none',
                                    color:'#F5F5FC', 
                                    backgroundColor:'#242323'
                                }} type='submit'>
                                  <LoginIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Login
                                </Button>
                              </Form.Group>
                            </Form.Row>
                            <Form.Row>
                              <Form.Group as={Col}>
                                <Form.Check 
                                  label='Use password instead of passkey'
                                  style={{color:'#00e5ff', fontSize:'1.2em'}}
                                  name='usePassword'
                                  ref={register()}
                                />
                              </Form.Group>
                            </Form.Row>    
                            <Form.Row>
                              <Form.Group as={Col}>
                                <small>
                                  <Link className='color' to={{
                                      pathname: props.forgotUsernamePath || '/forgotUsername',
                                      }}>Forgot Username</Link>
                                </small>
                              </Form.Group>
                            </Form.Row>
                            <Form.Row>
                              <Form.Group as={Col}>
                                <br/>
                                <br/>
                              </Form.Group>
                            </Form.Row> 
                            <Form.Row>
                              <Form.Group as={Col}>
                                <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>
                                  Create Passkey&ensp;
                                  <Button 
                                    size='sm' 
                                    variant='outline-light' 
                                    style={{border:'none', backgroundColor:'transparent'}}
                                    onClick={() => setShowPasskeyHelp(true)}
                                  >
                                      <HelpIcon fill='#00e5ff' height='1.75em' width='1.75em' /> 
                                  </Button>
                                </Form.Label> 
                                <Button
                                  block
                                  style={{
                                    border:'none',
                                    color:'#F5F5FC', 
                                    backgroundColor:'#242323'
                                  }}
                                  onClick={() => setDisplay({
                                    code: false, 
                                    username: false, 
                                    password: false,
                                    codeChoice: false,
                                    passkeyName: true,
                                    passkeyChoice: false,
                                    passkeyCode: false,
                                  })}
                                >
                                  <LoginIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Create Passkey
                                </Button>
                              </Form.Group>    
                            </Form.Row>   
                          </Form>
                        }
                        {display.password &&
                          <Form onSubmit={handleSubmit(passwordSubmit)}>  
                            <Form.Row>
                              <Form.Group as={Col}>
                                <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>Password</Form.Label>
                                <Form.Control ref={register({ required: true })} name='password' type='password'/>
                              </Form.Group>
                            </Form.Row>     
                            <Form.Row>
                              <Form.Group as={Col}>
                                <Button block
                                  style={{
                                    border:'none',
                                    color:'#F5F5FC', 
                                    backgroundColor:'#242323'
                                }} type='submit'>
                                  <LoginIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Login
                                </Button>
                              </Form.Group>
                            </Form.Row>
                            <Form.Row>
                              <Form.Group as={Col}>
                                <small>
                                  <Link className='color' to={{
                                      pathname: props.resetPath || '/resetPassword',
                                      }}>Reset Password</Link>
                                </small>
                              </Form.Group>
                            </Form.Row>
                          </Form>
                        }
                        {display.codeChoice &&
                          <>
                            <Form>
                              <Form.Row>
                                <Form.Group as={Col}>
                                  <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>One time code</Form.Label> 
                                  <Button
                                    block
                                    style={{
                                      border:'none',
                                      color:'#F5F5FC', 
                                      backgroundColor:'#242323'
                                    }}
                                    onClick={() => sendEmailCode()}
                                  >
                                    <EmailIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Email
                                  </Button>
                                  <Button
                                    block
                                    style={{
                                      border:'none',
                                      color:'#F5F5FC', 
                                      backgroundColor:'#242323'
                                    }}
                                    onClick={() => sendTextCode()}
                                  >
                                    <TextIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Text
                                  </Button>
                                </Form.Group>
                              </Form.Row>
                            </Form>
                          </>
                        }
                        {display.code &&
                          <>
                            <Form onSubmit={handleSubmit(codeSubmit)}>
                              <Form.Row>
                                <Form.Group as={Col}>
                                  <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>One time code</Form.Label>
                                  <br/>
                                  <br/>
                                  {inputs.current.map((ref, i) => (
                                    <input
                                      key={i}
                                      name={`code${i}`}
                                      type="text"
                                      maxLength="1"
                                      autoComplete="one-time-code"
                                      inputMode="numeric"
                                      pattern="\d*"
                                      ref={(el) => {
                                        ref.current = el
                                        register(el)
                                      }}
                                      onChange={(e) => handleChange(e, i)}
                                      onKeyDown={(e) => handleKeyDown(e, i)}
                                      onPaste={i === 0 ? handlePaste : undefined} 
                                      style={{ 
                                        width: '2em', 
                                        textAlign: 'center', 
                                        fontSize: '1.5em', 
                                        borderColor:'#00e5ff', 
                                        backgroundColor:'transparent', 
                                        color:'#F5F5FC', 
                                        borderRadius:'.25em', 
                                        marginLeft:'.1em', 
                                        marginRight:'.1em'
                                      }}
                                      
                                    />
                                  ))}
                                  <br/>
                                  <br/>
                                  <Button 
                                    style={{
                                      border:'none',
                                      color:'#F5F5FC', 
                                      backgroundColor:'#242323'
                                    }} 
                                    type="submit"
                                  >
                                    <LoginIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Verify code
                                  </Button>
                                  <br/>
                                  <br/>
                                  <Button size='sm' style={{
                                    border:'none',
                                    color:'#F5F5FC', 
                                    backgroundColor:'#242323'
                                  }}
                                    onClick={() => setShowCodeOptions(!showCodeOptions)}
                                  >
                                    {!showCodeOptions ? 'Request new code' : 'Close'}
                                  </Button>
                                  {showCodeOptions &&
                                    <>
                                      <Form.Row style={{marginTop:'1em'}}>
                                        <Form.Group as={Col}>
                                          <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>One time code</Form.Label> 
                                          <Button
                                            block
                                            style={{
                                              border:'none',
                                              color:'#F5F5FC', 
                                              backgroundColor:'#242323'
                                            }}
                                            onClick={() => sendEmailCode()}
                                          >
                                            <EmailIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Email
                                          </Button>
                                          <Button
                                            block
                                            style={{
                                              border:'none',
                                              color:'#F5F5FC', 
                                              backgroundColor:'#242323'
                                            }}
                                            onClick={() => sendTextCode()}
                                          >
                                            <TextIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Text
                                          </Button>
                                        </Form.Group>
                                      </Form.Row>
                                    </>
                                  }
                                </Form.Group>
                              </Form.Row>
                            </Form>
                          </>
                        }
                          {display.passkeyName &&
                          <>
                            <Form onSubmit={handleSubmit(saveDeviceName)}>
                              <Form.Row>
                                <Form.Group as={Col}>
                                  <Form.Label style={{color:'#F5F5FC', fontSize:'1.4em'}}>Passkey information</Form.Label>
                                </Form.Group>
                              </Form.Row>
                              <Form.Row>
                                <Form.Group as={Col}>
                                  <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>Username</Form.Label> 
                                  <Form.Control ref={register({ required: true })} name='user' type='text'/>
                                </Form.Group>
                              </Form.Row> 
                              <Form.Row>
                                <Form.Group as={Col}>
                                  <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>
                                    Device name&ensp;
                                    <Button 
                                      size='sm' 
                                      variant='outline-light' 
                                      style={{border:'none', backgroundColor:'transparent'}}
                                      onClick={() => setShowDeviceNameHelp(true)}
                                    >
                                        <HelpIcon fill='#00e5ff' height='1.75em' width='1.75em' /> 
                                    </Button>
                                  </Form.Label> 
                                  <Form.Control ref={register({ required: true })} name='deviceName' type='text'/>
                                </Form.Group>
                              </Form.Row>     
                              <Form.Row>
                                <Form.Group as={Col}>
                                  <Button block
                                    style={{
                                      border:'none',
                                      color:'#F5F5FC', 
                                      backgroundColor:'#242323'
                                  }} type='submit'>
                                    Save and continue <StepNextIcon fill='#00e5ff' height='1.25em' width='1.25em' /> 
                                  </Button>
                                </Form.Group>
                              </Form.Row>
                            </Form>
                          </>
                        }
                        {display.passkeyChoice &&
                          <>
                            <Form>
                              <Form.Row>
                                <Form.Group as={Col}>
                                  <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>
                                    Passkey one time code
                                  </Form.Label> 
                                  <Button
                                    block
                                    style={{
                                      border:'none',
                                      color:'#F5F5FC', 
                                      backgroundColor:'#242323'
                                    }}
                                    onClick={() => emailPasskeyCode()}
                                  >
                                    <EmailIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Email
                                  </Button>
                                  <Button
                                    block
                                    style={{
                                      border:'none',
                                      color:'#F5F5FC', 
                                      backgroundColor:'#242323'
                                    }}
                                    onClick={() => textPasskeyCode()}
                                  >
                                    <TextIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Text
                                  </Button>
                                </Form.Group>    
                              </Form.Row>
                            </Form>
                          </>
                        }
                        {display.passkeyCode &&
                          <>
                            <Form onSubmit={handleSubmit(createPasskey)}>
                              <Form.Row>
                                <Form.Group as={Col}>
                                  <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>Passkey code</Form.Label>
                                  <br/>
                                  <br/>
                                  {inputs.current.map((ref, i) => (
                                    <input
                                      key={i}
                                      name={`code${i}`}
                                      type="text"
                                      maxLength="1"
                                      autoComplete="one-time-code"
                                      inputMode="numeric"
                                      pattern="\d*"
                                      ref={(el) => {
                                        ref.current = el
                                        register(el)
                                      }}
                                      onChange={(e) => handleChange(e, i)}
                                      onKeyDown={(e) => handleKeyDown(e, i)}
                                      onPaste={i === 0 ? handlePaste : undefined} 
                                      style={{ 
                                        width: '2em', 
                                        textAlign: 'center', 
                                        fontSize: '1.5em', 
                                        borderColor:'#00e5ff', 
                                        backgroundColor:'transparent', 
                                        color:'#F5F5FC', 
                                        borderRadius:'.25em', 
                                        marginLeft:'.1em', 
                                        marginRight:'.1em'
                                      }}
                                      
                                    />
                                  ))}
                                  <br/>
                                  <br/>
                                  <Button 
                                    style={{
                                      border:'none',
                                      color:'#F5F5FC', 
                                      backgroundColor:'#242323'
                                    }} 
                                    type="submit"
                                  >
                                    <LoginIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Create passkey 
                                  </Button>
                                  <br/>
                                  <br/>
                                  <Button size='sm' style={{
                                    border:'none',
                                    color:'#F5F5FC', 
                                    backgroundColor:'#242323'
                                  }}
                                    onClick={() => setShowCodeOptions(!showCodeOptions)}
                                  >
                                    {!showCodeOptions ? 'Request new code' : 'Close'}
                                  </Button>
                                  {showCodeOptions &&
                                    <>
                                      <Form.Row style={{marginTop:'1em'}}>
                                        <Form.Group as={Col}>
                                          <Form.Label style={{color:'#F5F5FC', fontSize:'1.2em'}}>Passkey code</Form.Label> 
                                          <Button
                                            block
                                            style={{
                                              border:'none',
                                              color:'#F5F5FC', 
                                              backgroundColor:'#242323'
                                            }}
                                            onClick={() => emailPasskeyCode()}
                                          >
                                            <EmailIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Email
                                          </Button>
                                          <Button
                                            block
                                            style={{
                                              border:'none',
                                              color:'#F5F5FC', 
                                              backgroundColor:'#242323'
                                            }}
                                            onClick={() => textPasskeyCode()}
                                          >
                                            <TextIcon fill='#00e5ff' height='1.25em' width='1.25em' /> Text
                                          </Button>
                                        </Form.Group>
                                      </Form.Row>
                                    </>
                                  }
                                </Form.Group>
                              </Form.Row>
                            </Form>
                          </>
                        }
                      </Col>
                    </Row>
                  </>
                }
              </>
            } 
          </>
        }
      </LoginFormContainer>
    </Container> 
  )
}

export default Loginform
